import React from 'react';
import { AtdwFeaturedSearch } from './view/atdwFeaturedSearch';

export const renderRule = {
  match: (item, cmsOption) => item.itemTypeCode === 'AtdwFeaturedSearch', 
  itemElt: (item, cmsOption) => <AtdwFeaturedSearch item={item} cmsOption={cmsOption} />
}